import React from 'react';
import PropTypes from 'prop-types';

import { ListItem, ListItemIcon, ListItemText  } from 'material-ui/List';
import CloseIcon from 'material-ui-icons/Close';

export function CloseMenuItem(props) {
  const { onClose } = props;

  return (
    <ListItem button onClick={onClose}>
      <ListItemIcon>
        <CloseIcon />
      </ListItemIcon>
      <ListItemText primary="Cancel" />
    </ListItem>
  );
}

CloseMenuItem.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default CloseMenuItem;


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/MenuDrawer/CloseMenuItem.js